(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sale-innovation"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-sale-innovation-carousel]';
    const mobileMedia = window.matchMedia('(max-width: 768px)');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    const initCarousel = (viewport) => {
      if (viewport.dataset.saleInnovationReady === 'true') return;

      const root = viewport.closest('.sale-innovation');
      const track = viewport.querySelector('[data-sale-innovation-track]');
      const slides = Array.from(viewport.querySelectorAll('[data-sale-innovation-slide]'));
      const controls = root?.querySelector('[data-sale-innovation-controls]');
      const previousButton = root?.querySelector('[data-sale-innovation-previous]');
      const nextButton = root?.querySelector('[data-sale-innovation-next]');

      if (!root || !track || !controls || !previousButton || !nextButton || slides.length < 2) return;

      viewport.dataset.saleInnovationReady = 'true';
      let frame;

      const getScroller = () => {
        if (mobileMedia.matches && root.classList.contains('sale-innovation--swipe')) return viewport;
        if (!mobileMedia.matches && root.classList.contains('sale-innovation--slider')) return track;
        return null;
      };

      const getSlidePositions = (scroller) => {
        const scrollerRect = scroller.getBoundingClientRect();
        return slides.map((slide) => (
          scroller.scrollLeft + slide.getBoundingClientRect().left - scrollerRect.left
        ));
      };

      const getCurrentIndex = (scroller, positions) => positions.reduce((closest, position, index) => (
        Math.abs(position - scroller.scrollLeft) < Math.abs(positions[closest] - scroller.scrollLeft) ? index : closest
      ), 0);

      const update = () => {
        const scroller = getScroller();
        const maximum = scroller ? Math.max(0, scroller.scrollWidth - scroller.clientWidth) : 0;
        const canScroll = Boolean(scroller && maximum > 2);
        const positions = canScroll ? getSlidePositions(scroller) : [];
        const currentIndex = canScroll ? getCurrentIndex(scroller, positions) : 0;

        controls.hidden = !canScroll;
        viewport.tabIndex = canScroll ? 0 : -1;
        previousButton.disabled = !canScroll || currentIndex === 0;
        nextButton.disabled = !canScroll || currentIndex === slides.length - 1 || maximum - scroller.scrollLeft <= 2;
      };

      const requestUpdate = () => {
        window.cancelAnimationFrame(frame);
        frame = window.requestAnimationFrame(update);
      };

      const move = (direction) => {
        const scroller = getScroller();
        if (!scroller) return;

        const positions = getSlidePositions(scroller);
        const currentIndex = getCurrentIndex(scroller, positions);
        const targetIndex = Math.max(0, Math.min(slides.length - 1, currentIndex + direction));
        const maximum = Math.max(0, scroller.scrollWidth - scroller.clientWidth);
        const left = Math.max(0, Math.min(maximum, positions[targetIndex]));

        scroller.scrollTo({
          left,
          behavior: reducedMotion.matches ? 'auto' : 'smooth'
        });
      };

      previousButton.addEventListener('click', () => move(-1));
      nextButton.addEventListener('click', () => move(1));
      viewport.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        move(event.key === 'ArrowLeft' ? -1 : 1);
      });
      viewport.addEventListener('scroll', requestUpdate, { passive: true });
      track.addEventListener('scroll', requestUpdate, { passive: true });
      window.addEventListener('resize', requestUpdate, { passive: true });
      mobileMedia.addEventListener('change', requestUpdate);

      if ('ResizeObserver' in window) {
        const observer = new ResizeObserver(requestUpdate);
        observer.observe(viewport);
        observer.observe(track);
      }

      requestUpdate();
    };

    const initWithin = (container) => {
      if (container.matches?.(selector)) initCarousel(container);
      container.querySelectorAll?.(selector).forEach(initCarousel);
    };

    initWithin(document);
    document.addEventListener('shopify:section:load', (event) => initWithin(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sale-lash-matcher"] && !Shopify.designMode) return;
  try {
    
  class SaleLashMatcher extends HTMLElement {
    connectedCallback() {
      this.buttons = Array.from(this.querySelectorAll('[data-sale-moment]'));
      this.cards = Array.from(this.querySelectorAll('[data-sale-moments]'));
      this.empty = this.querySelector('.sale-matcher__empty');
      this.onClick = (event) => this.handleClick(event);
      this.addEventListener('click', this.onClick);

      const active = this.buttons.find((button) => button.classList.contains('is-active'));
      if (active) this.filter(active.dataset.saleMoment);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
    }

    handleClick(event) {
      const button = event.target.closest('[data-sale-moment]');
      if (!button || !this.contains(button)) return;

      this.buttons.forEach((item) => item.classList.toggle('is-active', item === button));
      this.filter(button.dataset.saleMoment);
    }

    filter(moment) {
      let visibleCount = 0;

      this.cards.forEach((card) => {
        const moments = (card.dataset.saleMoments || '')
          .split(',')
          .map((item) => item.trim())
          .filter(Boolean);
        const show = moment === 'all' || moments.length === 0 || moments.includes(moment);
        card.hidden = !show;
        if (show) visibleCount += 1;
      });

      if (this.empty) this.empty.hidden = visibleCount > 0;
    }
  }

  if (!customElements.get('sale-lash-matcher')) {
    customElements.define('sale-lash-matcher', SaleLashMatcher);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sale-mood-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sale-mood-tabs')) {
    customElements.define('sale-mood-tabs', class extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
        this.carouselUpdates = [];
        this.tabs.forEach((tab) => {
          tab.addEventListener('click', () => this.activate(tab));
          tab.addEventListener('keydown', (event) => this.onKeydown(event));
        });
        this.addEventListener('shopify:block:select', (event) => {
          const panel = event.target.closest('[data-tab-panel]');
          const tab = event.target.closest('[role="tab"]') || this.querySelector(`[data-tab-key="${panel?.dataset.tabPanel}"]`);
          if (tab) this.activate(tab, true);
        });
        this.querySelectorAll('[data-sale-mood-rail]').forEach((rail) => this.setupCarousel(rail));
      }

      activate(tab, focus = false) {
        const key = tab.dataset.tabKey;
        this.tabs.forEach((item) => {
          const active = item === tab;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-selected', String(active));
          item.tabIndex = active ? 0 : -1;
        });
        this.panels.forEach((panel) => {
          panel.hidden = panel.dataset.tabPanel !== key;
        });
        requestAnimationFrame(() => this.carouselUpdates.forEach((update) => update()));
        if (focus) tab.focus();
      }

      setupCarousel(rail) {
        const scroller = rail.querySelector('[data-sale-mood-scroller]');
        const previous = rail.querySelector('[data-sale-mood-previous]');
        const next = rail.querySelector('[data-sale-mood-next]');
        const grid = rail.querySelector('.sale-mood__grid');
        if (!scroller || !previous || !next || !grid) return;

        const mobile = window.matchMedia('(max-width: 768px)');
        const update = () => {
          const maximum = Math.max(0, scroller.scrollWidth - scroller.clientWidth);
          const hasOverflow = mobile.matches && maximum > 3;
          previous.hidden = !hasOverflow;
          next.hidden = !hasOverflow;
          previous.disabled = !hasOverflow || scroller.scrollLeft <= 3;
          next.disabled = !hasOverflow || scroller.scrollLeft >= maximum - 3;
        };

        const move = (direction) => {
          const card = grid.querySelector('.sale-mood__card');
          if (!card) return;
          const gap = parseFloat(getComputedStyle(grid).columnGap || getComputedStyle(grid).gap) || 0;
          const distance = card.getBoundingClientRect().width + gap;
          scroller.scrollBy({
            left: direction * distance,
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
          });
        };

        previous.addEventListener('click', () => move(-1));
        next.addEventListener('click', () => move(1));
        scroller.addEventListener('scroll', update, { passive: true });
        mobile.addEventListener('change', update);
        if ('ResizeObserver' in window) {
          const observer = new ResizeObserver(update);
          observer.observe(scroller);
          observer.observe(grid);
        } else {
          window.addEventListener('resize', update, { passive: true });
        }
        this.carouselUpdates.push(update);
        requestAnimationFrame(update);
      }

      onKeydown(event) {
        const index = this.tabs.indexOf(event.currentTarget);
        let next = index;
        if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
        if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = this.tabs.length - 1;
        if (next === index) return;
        event.preventDefault();
        this.activate(this.tabs[next], true);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-hero"] && !Shopify.designMode) return;
  try {
    
  class KitShoppableHero extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      if (window.theme && window.theme.sections) {
        this.initQuickShop();
      } else {
        document.addEventListener('page:loaded', () => this.initQuickShop(), { once: true, signal });
      }

      if (this.querySelector('kit-popover')) {
        window.addEventListener('scroll', () => {
          this.querySelectorAll('kit-popover:popover-open').forEach(p => p.hidePopover());
        }, { passive: true, signal });
      }

      if (!Shopify.designMode) return;

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.contains(this)) {
          this.initQuickShop();
        }
      }, { signal });

      this.addEventListener('shopify:block:select', (event) => {
        this.initQuickShop();
        const btn = event.target.querySelector('button');
        if (btn) btn.click();
      }, { signal });

      this.addEventListener('shopify:block:deselect', (event) => {
        const popover = event.target.querySelector('kit-popover');
        if (popover) popover.hidePopover?.();
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    initQuickShop() {
      if (!theme.settings.quickView) return;

      var sectionEl = this.closest('[id^="shopify-section-"]');
      var links = this.querySelectorAll('.shoppable-hero__popover-link[data-product-handle]');
      if (!links.length) return;

      links.forEach(link => {
        if (link.dataset.shoppableHeroBound === 'true') return;
        link.dataset.shoppableHeroBound = 'true';

        var handle = link.dataset.productHandle;
        var productId = link.dataset.productId;

        if (!document.getElementById('QuickShopModal-' + productId)) return;

        // Capture-phase interceptor registered before modal binds its handler.
        // On mobile, blocks the modal handler so the link navigates normally.
        link.addEventListener('click', (event) => {
          if (theme.config.bpSmall) {
            event.stopImmediatePropagation();
            return;
          }
          const popover = event.target.closest('kit-popover');
          if (popover) popover.hidePopover?.();
        }, true);

        var hotspot = link.closest('.kit-shoppable-hero__hotspot');
        if (!hotspot) return;

        var preloadOnce = function() {
          if (link.dataset.shoppableHeroPreloaded === 'true') return;
          if (theme.config.bpSmall) return;

          // If a holder already exists from another section (e.g. product grid),
          // remove our duplicate modal shell to avoid duplicate IDs
          var holder = document.getElementById('QuickShopHolder-' + handle);
          if (holder && sectionEl) {
            var holderSection = holder.closest('[id^="shopify-section-"]');
            if (holderSection && holderSection !== sectionEl) {
              var duplicate = sectionEl.querySelector('#QuickShopModal-' + productId);
              if (duplicate) duplicate.remove();
            }
          }

          link.dataset.shoppableHeroPreloaded = 'true';
          link.classList.add('js-modal-open-quick-modal-' + productId);
          theme.preloadProductModal(handle, productId, link);

          hotspot.removeEventListener('mouseover', preloadOnce);
          hotspot.removeEventListener('focusin', preloadOnce);
        };

        hotspot.addEventListener('mouseover', preloadOnce);
        hotspot.addEventListener('focusin', preloadOnce);
      });
    }
  }

  customElements.define('kit-shoppable-hero', KitShoppableHero);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-video-carousel"] && !Shopify.designMode) return;
  try {
    
  class ShoppableVideoCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-shoppable-video-track]');
      this.previousButton = this.querySelector('[data-shoppable-video-previous]');
      this.nextButton = this.querySelector('[data-shoppable-video-next]');

      if (!this.track) return;

      this.onPrevious = () => this.scroll(-1);
      this.onNext = () => this.scroll(1);
      this.onScroll = () => this.updateArrows();
      this.onChange = (event) => this.updateVariant(event);
      this.onClick = (event) => this.handleClick(event);
      this.onMediaPlay = (event) => this.updateMediaState(event, true);
      this.onMediaPause = (event) => this.updateMediaState(event, false);

      this.previousButton?.addEventListener('click', this.onPrevious);
      this.nextButton?.addEventListener('click', this.onNext);
      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      this.addEventListener('change', this.onChange);
      this.addEventListener('click', this.onClick);
      this.addEventListener('media:play', this.onMediaPlay);
      this.addEventListener('media:pause', this.onMediaPause);

      this.resizeObserver = new ResizeObserver(() => this.updateArrows());
      this.resizeObserver.observe(this.track);
      this.updateArrows();
    }

    disconnectedCallback() {
      this.previousButton?.removeEventListener('click', this.onPrevious);
      this.nextButton?.removeEventListener('click', this.onNext);
      this.track?.removeEventListener('scroll', this.onScroll);
      this.removeEventListener('change', this.onChange);
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('media:play', this.onMediaPlay);
      this.removeEventListener('media:pause', this.onMediaPause);
      this.resizeObserver?.disconnect();
    }

    scroll(direction) {
      const card = this.track.querySelector('.shoppable-video__card');
      const gap = Number.parseFloat(getComputedStyle(this.track).gap) || 0;
      const distance = card ? card.getBoundingClientRect().width + gap : this.track.clientWidth * 0.8;
      this.track.scrollBy({ left: direction * distance, behavior: 'smooth' });
    }

    updateArrows() {
      const maximum = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      const hasOverflow = maximum > 2;

      if (this.previousButton) {
        this.previousButton.hidden = !hasOverflow;
        this.previousButton.disabled = this.track.scrollLeft <= 2;
      }

      if (this.nextButton) {
        this.nextButton.hidden = !hasOverflow;
        this.nextButton.disabled = this.track.scrollLeft >= maximum - 2;
      }
    }

    handleClick(event) {
      const pauseButton = event.target.closest('[data-shoppable-video-pause]');

      if (pauseButton) {
        event.preventDefault();

        const card = pauseButton.closest('.shoppable-video__card');
        const media = card?.querySelector('video-media');

        if (media?.hasAttribute('playing') && typeof media.pause === 'function') {
          media.pause();
        }

        return;
      }

      const playButton = event.target.closest('[data-shoppable-video-play]');
      if (!playButton) return;

      event.preventDefault();

      const card = playButton.closest('.shoppable-video__card');
      const media = card?.querySelector('video-media');
      if (!media) return;

      this.pauseOtherVideos(media);

      const play = () => {
        if (media.hasAttribute('defer-hydration')) {
          media.removeAttribute('defer-hydration');
        }

        requestAnimationFrame(() => media.play());
      };

      if (typeof media.play === 'function') {
        play();
      } else {
        media.click();
        customElements.whenDefined('video-media').then(play);
      }
    }

    pauseOtherVideos(activeMedia) {
      this.querySelectorAll('video-media[playing]').forEach((media) => {
        if (media !== activeMedia && typeof media.pause === 'function') {
          media.pause();
        }
      });
    }

    updateMediaState(event, isPlaying) {
      const card = event.target.closest('.shoppable-video__card');
      const playButton = card?.querySelector('[data-shoppable-video-play]');

      card?.classList.toggle('is-playing', isPlaying);
      if (playButton) playButton.hidden = isPlaying;
    }

    updateVariant(event) {
      const select = event.target.closest('[data-shoppable-video-variant]');
      if (!select) return;

      const form = select.closest('form');
      const card = select.closest('.shoppable-video__card');
      const option = select.selectedOptions[0];
      const hiddenVariant = form?.querySelector('input[name="id"]');
      const price = card?.querySelector('[data-shoppable-video-price]');
      const addButton = form?.querySelector('[data-shoppable-video-add]');
      const isAvailable = option?.dataset.available === 'true';

      const update = () => {
        if (hiddenVariant) hiddenVariant.value = select.value;
        if (price && option?.dataset.price) price.textContent = option.dataset.price;
        if (addButton) addButton.disabled = !isAvailable;
      };

      if (document.startViewTransition) {
        document.startViewTransition(update);
      } else {
        update();
      }
    }
  }

  if (!customElements.get('shoppable-video-carousel')) {
    customElements.define('shoppable-video-carousel', ShoppableVideoCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ucm-black-friday-hub"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const parseTime = (value, fallback = Number.NaN) => {
      if (!value) return fallback;
      const parsed = Date.parse(value);
      return Number.isNaN(parsed) ? fallback : parsed;
    };

    const resolvePhase = (items, mode, manualPhase) => {
      if (mode !== 'automatic') return manualPhase;
      const now = Date.now();
      const phases = items
        .map((item) => ({
          phase: item.dataset.phase,
          start: parseTime(item.dataset.start),
          end: parseTime(item.dataset.end, Number.POSITIVE_INFINITY)
        }))
        .filter((phase) => !Number.isNaN(phase.start))
        .sort((a, b) => a.start - b.start);

      if (!phases.length) return manualPhase;
      const current = phases.find((phase) => now >= phase.start && now < phase.end);
      if (current) return current.phase;
      if (now < phases[0].start) return phases[0].phase;
      return phases[phases.length - 1].phase;
    };

    const updatePhaseRoot = (root) => {
      const timeline = root.querySelector('[data-bf-timeline]');
      if (!timeline) return;
      const items = Array.from(timeline.querySelectorAll('[data-phase]'));
      const selectedPhase = resolvePhase(items, root.dataset.phaseMode, root.dataset.manualPhase);
      const selectedIndex = items.findIndex((item) => item.dataset.phase === selectedPhase);
      const now = Date.now();

      root.querySelectorAll('[data-bf-phase-panel]').forEach((panel) => {
        panel.hidden = panel.dataset.bfPhasePanel !== selectedPhase;
      });

      items.forEach((item, index) => {
        const isActive = item.dataset.phase === selectedPhase;
        let progress = index < selectedIndex ? 100 : 0;

        if (root.dataset.phaseMode === 'automatic') {
          const start = parseTime(item.dataset.start);
          const end = parseTime(item.dataset.end, Number.POSITIVE_INFINITY);
          if (!Number.isNaN(start) && now >= start) {
            if (Number.isFinite(end) && end > start) {
              progress = Math.min(100, Math.max(0, (now - start) / (end - start) * 100));
            } else {
              progress = 100;
            }
          }
        }

        item.style.setProperty('--phase-progress', `${progress}%`);
        item.classList.toggle('is-active', isActive);
        if (isActive) item.setAttribute('aria-current', 'step');
        else item.removeAttribute('aria-current');
      });
    };

    const initPhases = (scope) => {
      if (scope.matches?.('[data-bf-root]')) updatePhaseRoot(scope);
      scope.querySelectorAll?.('[data-bf-root]').forEach(updatePhaseRoot);
    };

    const initCountdowns = (scope) => {
      scope.querySelectorAll('[data-bf-countdown]').forEach((timer) => {
        if (timer.dataset.bound === 'true') return;
        timer.dataset.bound = 'true';
        const end = Date.parse(timer.dataset.end);
        if (Number.isNaN(end)) return;
        const fields = {
          days: timer.querySelector('[data-days]'),
          hours: timer.querySelector('[data-hours]'),
          minutes: timer.querySelector('[data-minutes]'),
          seconds: timer.querySelector('[data-seconds]')
        };
        const render = () => {
          const remaining = Math.max(0, end - Date.now());
          const totalSeconds = Math.floor(remaining / 1000);
          const values = {
            days: Math.floor(totalSeconds / 86400),
            hours: Math.floor(totalSeconds % 86400 / 3600),
            minutes: Math.floor(totalSeconds % 3600 / 60),
            seconds: totalSeconds % 60
          };
          Object.keys(values).forEach((key) => {
            if (fields[key]) fields[key].textContent = String(values[key]).padStart(2, '0');
          });
          if (remaining === 0) {
            window.clearInterval(interval);
            timer.classList.add('is-expired');
            const heading = timer.querySelector(':scope > p');
            if (heading && timer.dataset.expired) heading.textContent = timer.dataset.expired;
          }
        };
        const interval = window.setInterval(render, 1000);
        render();
      });
    };

    initPhases(document);
    initCountdowns(document);
    document.addEventListener('shopify:section:load', (event) => {
      initPhases(event.target);
      initCountdowns(event.target);
    });

    if (!window.ucmBlackFridayPhaseClock) {
      window.ucmBlackFridayPhaseClock = window.setInterval(() => initPhases(document), 60000);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ucm-pro-video-showcase"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ucm-pro-video-showcase')) {
    customElements.define('ucm-pro-video-showcase', class extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('[data-dialog]');
        this.content = this.querySelector('[data-content]');
        this.addEventListener('click', event => {
          const open = event.target.closest('[data-open]');
          if (open && this.contains(open)) { this.openVideo(Number(open.dataset.open)); return; }
          if (event.target.closest('[data-close]')) this.dialog.close();
          const add = event.target.closest('[data-add]');
          if (add && this.dialog.contains(add)) this.addToCart(add);
        });
        this.dialog.addEventListener('click', event => {
          if (event.target === this.dialog) this.dialog.close();
        });
        this.dialog.addEventListener('close', () => {
          const video = this.content.querySelector('video');
          if (video) video.pause();
          this.content.replaceChildren();
          document.body.style.overflow = '';
        });
        this.dialog.addEventListener('change', event => {
          const select = event.target.closest('[data-variant]');
          if (!select) return;
          const item = select.closest('.ucm-pro-video__product');
          const option = select.selectedOptions[0];
          item.querySelector('[data-price]').textContent = option.dataset.price;
          const button = item.querySelector('[data-add]');
          button.dataset.variantId = option.value;
          button.disabled = option.dataset.available !== 'true';
        });
      }
      openVideo(index) {
        const template = this.querySelector('template[data-video-template="' + index + '"]');
        if (!template) return;
        const current = this.content.querySelector('video');
        if (current) current.pause();
        this.content.replaceChildren(template.content.cloneNode(true));
        this.querySelectorAll('.ucm-pro-video__thumbnails [data-open]').forEach(button => {
          button.setAttribute('aria-current', String(Number(button.dataset.open) === index));
        });
        if (!this.dialog.open) {
          this.dialog.showModal();
          document.body.style.overflow = 'hidden';
        }
        const video = this.content.querySelector('video');
        if (video) video.play().catch(() => {});
        this.refreshCart();
      }
      async refreshCart() {
        try {
          const root = window.Shopify?.routes?.root || '/';
          const response = await fetch(root + 'cart.js', { credentials: 'same-origin' });
          if (!response.ok) return;
          const cart = await response.json();
          const subtotal = this.content.querySelector('[data-subtotal]');
          const count = this.content.querySelector('[data-cart-count]');
          if (!subtotal || !count) return;
          const currency = cart.currency || this.dataset.currency || 'USD';
          subtotal.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency }).format(cart.total_price / 100);
          count.textContent = '(' + cart.item_count + ')';
        } catch (error) {}
      }
      async addToCart(button) {
        button.disabled = true;
        const status = this.content.querySelector('[data-status]');
        try {
          const root = window.Shopify?.routes?.root || '/';
          const response = await fetch(root + 'cart/add.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: Number(button.dataset.variantId), quantity: 1 })
          });
          if (!response.ok) throw new Error('cart');
          status.textContent = this.dataset.addedLabel;
          await this.refreshCart();
        } catch (error) {
          status.textContent = this.dataset.errorLabel;
        } finally {
          button.disabled = false;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ucoolme-featured-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ucoolme-collection-tabs')) {
    customElements.define('ucoolme-collection-tabs', class extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
        this.viewAllLinks = Array.from(this.querySelectorAll('[data-view-all-index]'));

        this.tabs.forEach((tab) => {
          tab.addEventListener('click', () => this.activate(Number(tab.dataset.tabIndex)));
          tab.addEventListener('keydown', (event) => this.handleKeydown(event));
        });

        this.addEventListener('shopify:block:select', (event) => {
          const tab = this.querySelector(`[data-block-id="${event.detail.blockId}"]`);
          if (tab) this.activate(Number(tab.dataset.tabIndex), true);
        });

        this.enhanceCards();
      }

      activate(index, focus = false) {
        this.tabs.forEach((tab, tabIndex) => {
          const active = tabIndex === index;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
          if (active && focus) tab.focus();
        });

        this.panels.forEach((panel) => {
          panel.hidden = Number(panel.dataset.tabPanel) !== index;
        });

        this.viewAllLinks.forEach((link) => {
          link.hidden = Number(link.dataset.viewAllIndex) !== index;
        });
      }

      handleKeydown(event) {
        const currentIndex = this.tabs.indexOf(event.currentTarget);
        let nextIndex = currentIndex;

        if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % this.tabs.length;
        if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = this.tabs.length - 1;
        if (nextIndex === currentIndex) return;

        event.preventDefault();
        this.activate(nextIndex, true);
      }

      async enhanceCards() {
        const cards = Array.from(this.querySelectorAll('.grid-product[data-product-handle]'));
        await Promise.all(cards.map((card) => this.addCta(card)));
      }

      async addCta(card) {
        if (card.dataset.ucmCtaReady === 'true') return;
        card.dataset.ucmCtaReady = 'true';

        const handle = card.dataset.productHandle;
        const wrapper = card.querySelector('.grid__item-image-wrapper');
        if (!handle || !wrapper) return;

        try {
          const root = window.Shopify?.routes?.root || '/';
          const response = await fetch(`${root}products/${encodeURIComponent(handle)}.js`);
          if (!response.ok) throw new Error(`Product request failed: ${response.status}`);

          const product = await response.json();
          const availableVariants = product.variants.filter((variant) => variant.available);

          if (availableVariants.length === 0) {
            const button = document.createElement('button');
            button.className = 'ucoolme-collection-tabs__cta';
            button.disabled = true;
            button.type = 'button';
            button.textContent = this.dataset.soldOutLabel;
            wrapper.append(button);
            return;
          }

          if (product.variants.length === 1) {
            const form = document.createElement('form');
            form.action = `${root}cart/add`;
            form.className = 'ucoolme-collection-tabs__cta-form';
            form.method = 'post';

            const variantInput = document.createElement('input');
            variantInput.name = 'id';
            variantInput.type = 'hidden';
            variantInput.value = String(availableVariants[0].id);

            const quantityInput = document.createElement('input');
            quantityInput.name = 'quantity';
            quantityInput.type = 'hidden';
            quantityInput.value = '1';

            const button = document.createElement('button');
            button.className = 'ucoolme-collection-tabs__cta';
            button.name = 'add';
            button.type = 'submit';
            button.textContent = this.dataset.addLabel;

            form.append(variantInput, quantityInput, button);
            wrapper.append(form);
            return;
          }

          const link = document.createElement('a');
          link.className = 'ucoolme-collection-tabs__cta';
          link.href = `${root}products/${encodeURIComponent(handle)}`;
          link.textContent = this.dataset.selectLabel;
          wrapper.append(link);
        } catch (error) {
          card.dataset.ucmCtaReady = 'false';
          console.error('uCoolMe collection tabs:', error);
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
